import esquire from "@/types/clients/esquire";
import GetCountries from "@/types/clients/esquire/requests/general/get-countries";
import Country from "@/types/clients/esquire/data/general/country";

export const getCountriesRequest = new GetCountries(esquire);
class CountryApi {
  async index(): Promise<Country[]> {
    return await getCountriesRequest.send();
  }
}

export default new CountryApi();
